/**
 * コモンクラス
 * @constructor
 */
class Common {
  constructor() {

  }
  /**
   * コモン
   */
  init() {
    $(document).ready(function () {
      buttonTop();

      var lastScrollTop = 0, delta = 5;
      $(window).scroll(function(){
        if ($(window).width() > 768) {
          var nowScrollTop = $(this).scrollTop();
          var menuHeight = $('.j-menu').height();
          if(Math.abs(lastScrollTop - nowScrollTop) >= delta){
            if (nowScrollTop > lastScrollTop && $(this).scrollTop() >= menuHeight){
               $('.p-menu').css({'top':'0'});
               $('.j-nav-link').addClass("no-arrow");
            } else {
               $('.p-menu').css({'top':'96px'});
               $('.j-nav-link').removeClass("no-arrow");
             }
          lastScrollTop = nowScrollTop;
          }
        }
      });
    });


    
    function buttonTop() {
      var windowW = $(window).width();
      var topW = windowW * 0.9;
      var pos = $('footer').height() - topW;
      $(window).scroll(function () {
        if ($(document).scrollTop() > 100) {
          $('.j-top-page').css({ 'opacity': '1', 'visibility': 'visible' });
        } else {
          $('.j-top-page').css({ 'opacity': '0', 'visibility': 'hidden' });
        }
        if ($(window).scrollTop() + $(window).height() > $(document).height() - pos) {
          // $('.j-top-page').css({ 'position': 'absolute', 'top': '-12.766vw' });
        }
        else {
          $('.j-top-page').css({ 'position': 'fixed', 'top': 'auto' });
        }
    
      });
    }
    
  }

}

export default Common;
